function serialize(val: any) {
  return JSON.stringify(val);
}

function deserialize(val: any) {
  if (typeof val !== 'string') {
    return undefined;
  }
  try {
    return JSON.parse(val);
  } catch (e) {
    return val || undefined;
  }
}

const api = {
  set(key: any, val: any, noId?: boolean) {
    // @ts-ignore
    if (this.disabled) {
      return;
    }
    if (val === undefined) {
      return this.remove(key);
    }
    // @ts-ignore
    this.storage.setItem(`${noId ? '' : this.storage.getItem('UID')|| ''}${key}`, serialize(val));
    return val;
  },

  get(key: any, def: any, noId?: boolean) {

    // @ts-ignore
    if (this.disabled) {
      return def;
    }
    // @ts-ignore
    const val = deserialize(this.storage.getItem(`${noId ? '' : this.storage.getItem('UID') || ''}${key}`));
    return (val === undefined ? def : val);
  },

  has(key: any) {
    //@ts-ignore
    return this.get(key) !== undefined;
  },

  remove(key: any) {
    // @ts-ignore
    if (this.disabled) {
      return;
    }
    // @ts-ignore
    this.storage.removeItem(key);
    // @ts-ignore
    this.storage.removeItem(`${this.storage.getItem('UID') || ''}${key}`);
  },

  clear() {
    // @ts-ignore
    if (this.disabled) {
      return;
    }
    // @ts-ignore
    this.storage.clear();
  },

  getAll() {
    // @ts-ignore
    if (this.disabled) {
      return null;
    }
    const ret: any = {};
    this.forEach((key: any, val: any) => {
      ret[key] = val;
    });
    return ret;
  },

  forEach(callback: any) {
    // @ts-ignore
    if (this.disabled) {
      return;
    }
    // @ts-ignore
    for (let i = 0; i < this.storage.length; i++) {
      // @ts-ignore
      const key = this.storage.key(i);
      // @ts-ignore
      callback(key, this.get(key));
    }
  },
};

/**
  封装本地存储
*/
const localStore = {
  storage: window.localStorage,
  session: {
    storage: window.sessionStorage,
    ...api,
  },
  ...api,
};

export default localStore;
